import { useEffect, useRef, useState } from "react";

export function CountUp({ value = 0, className = "", duration = 1100 }) {
  const [display, setDisplay] = useState(0);
  const ref = useRef();
  const startedFrom = useRef(0);

  useEffect(() => {
    const from = startedFrom.current;
    const to = Number(value) || 0;
    const start = performance.now();
    cancelAnimationFrame(ref.current);
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(from + (to - from) * eased));
      if (p < 1) ref.current = requestAnimationFrame(tick);
      else startedFrom.current = to;
    };
    ref.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(ref.current);
  }, [value, duration]);

  return <span className={className} aria-live="polite">{display}</span>;
}
